// サーバーは 1 回に 50 件までしか保存しないので、送り手も 50 件ずつに分ける
export const LP_EVENTS_CHUNK_SIZE = 50;

export function chunkLpEvents<T>(
  events: readonly T[],
  size = LP_EVENTS_CHUNK_SIZE,
): T[][] {
  const chunks: T[][] = [];
  for (let i = 0; i < events.length; i += size) {
    chunks.push(events.slice(i, i + size));
  }
  return chunks;
}
